<template>
  <div
    class="chelp-container -flush chelp-open chelp-fade-start"
    :class="[
      {
        'chelp-fade-end': fadeOut,
      },
      classes,
    ]"
    aria-live="polite"
    role="status"
  >
    <p>
      {{ title }}
    </p>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

/**
 * Auto fading notification.  This notification instantly shows when used, so
 * parent component should v-if to show / hde
 */
export default defineComponent({
  name: 'AutoFadeHelp',
  props: {
    title: {
      type: String,
      required: true,
    },
    classes: {
      type: String,
      default: '',
    },
  },

  // component state
  data() {
    return {
      fadeOut: false,
    }
  },

  // lifecycle
  mounted() {
    // wait a little bit before adding the fade out class
    // TODO: make ms dynamic
    setTimeout(() => (this.fadeOut = true), 1500)
  },

  // component methods
  methods: {},
})
</script>
